import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CreditCard, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CibilCheck() {
  return (
    <div className="space-y-6 max-w-2xl">
      <Card variant="elevated">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <CreditCard className="h-5 w-5 text-accent" />
            CIBIL Score Check
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Check your customer's CIBIL score to determine loan eligibility. A higher score 
              increases approval chances and may result in better interest rates.
            </p>

            <div className="grid gap-3">
              <div className="flex items-center justify-between p-4 rounded-lg bg-success/10 border border-success/20">
                <div>
                  <p className="font-semibold text-success">Excellent (750+)</p>
                  <p className="text-xs text-muted-foreground">Best rates, quick approvals</p>
                </div>
              </div>
              <div className="flex items-center justify-between p-4 rounded-lg bg-accent/10 border border-accent/20">
                <div>
                  <p className="font-semibold text-accent">Good (700-749)</p>
                  <p className="text-xs text-muted-foreground">Competitive rates available</p>
                </div>
              </div>
              <div className="flex items-center justify-between p-4 rounded-lg bg-warning/10 border border-warning/20">
                <div>
                  <p className="font-semibold text-warning">Fair (650-699)</p>
                  <p className="text-xs text-muted-foreground">Limited options, higher rates</p>
                </div>
              </div>
              <div className="flex items-center justify-between p-4 rounded-lg bg-destructive/10 border border-destructive/20">
                <div>
                  <p className="font-semibold text-destructive">Poor (Below 650)</p>
                  <p className="text-xs text-muted-foreground">Difficult to get approval</p>
                </div>
              </div>
            </div>

            <div className="pt-4 space-y-3">
              <Button variant="accent" className="w-full" asChild>
                <a href="https://www.cibilscore.com" target="_blank" rel="noopener noreferrer">
                  Check CIBIL Score Online
                  <ExternalLink className="h-4 w-4 ml-2" />
                </a>
              </Button>
              <p className="text-xs text-center text-muted-foreground">
                Customer will be redirected to official CIBIL website
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
